// src/pages/Reports/ReserveSurplusLedger/reserveSurplusLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccountBySeachApi } from "../../../apiservice/setting";
import { getReserveSurplusLedgerApi } from "../../../apiservice/reports";
import { currentDateEndTime, currentDateStartTime } from "../../../lib/functions";

export const fetchReserveSurplusAccounts = createAsyncThunk(
  "reserveSurplusLedger/fetchAccounts",
  async (query, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: query || undefined,   // send query only if user typed
        multiType: ["reserve_surplus"],
      });
      return res.data?.length > 0 ? res.data : [];
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);



export const fetchReserveSurplusLedger = createAsyncThunk(
  "reserveSurplusLedger/fetchLedger",
  async (filters, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters.account?.acc_id,
        dateFrom: filters.fromDate,
        dateTo: filters.toDate,
      };
      const res = await getReserveSurplusLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error fetching ledger data");
    }
  }
);
